import { useClerkEntitlementSync } from "@/hooks/useClerkEntitlementSync";

/**
 * Mount once under ClerkProvider to mirror Clerk Billing into access_level / plan cookies.
 */
export default function ClerkEntitlementBridge() {
  useClerkEntitlementSync();
  return null;
}
